// Module
var code = "<div class=\"flex-content\"> <div class=\"pull-left\">{{vm.titleText}}</div> <div class=\"assignee\"> <wt-trackable-picture ng-if=\"vm.trackable && (vm.trackable.createdBy || vm.trackable.modifiedBy)\" placement=\"bottom-right\" show-popover=\"true\" trackable=\"vm.trackable\"> </wt-trackable-picture> </div> </div>";
// Exports
module.exports = code;